<div #current class="govuk-!-display-none">
  <ng-content select="[slot=current]" />
</div>

<div #previous class="govuk-!-display-none">
  <ng-content select="[slot=previous]" />
</div>

<!-- eslint-disable-next-line @angular-eslint/template/interactive-supports-focus -->
<div class="highlight" (click)="onClickDiff($event)" (keydown)="onClickDiff($event)" [innerHtml]="htmlDiff"></div>
